import * as React from 'react';
import { BeeContext } from '../context/bee';

export const useBee = () => React.useContext(BeeContext);
